var map = {
	"./IC-card.svg": "F9F1",
	"./close.svg": "toIl",
	"./face-recognition.svg": "2fst",
	"./icon-enlarge.svg": "DhAu",
	"./icon-focus-close.svg": "7Mu3",
	"./icon-focus-far.svg": "eapX",
	"./icon-narrow.svg": "4sbN",
	"./zgj.svg": "B73K"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 1